export const iso4217CurrencyCodes = [
  {
    code: 'AED',
    decimals: 2,
  },
  {
    code: 'AFN',
    decimals: 2,
  },
  {
    code: 'ALL',
    decimals: 2,
  },
  {
    code: 'AMD',
    decimals: 2,
  },
  {
    code: 'ANG',
    decimals: 2,
  },
  {
    code: 'AOA',
    decimals: 2,
  },
  {
    code: 'ARS',
    decimals: 2,
  },
  {
    code: 'AUD',
    decimals: 2,
  },
  {
    code: 'AWG',
    decimals: 2,
  },
  {
    code: 'AZN',
    decimals: 2,
  },
  {
    code: 'BAM',
    decimals: 2,
  },
  {
    code: 'BBD',
    decimals: 2,
  },
  {
    code: 'BDT',
    decimals: 2,
  },
  {
    code: 'BGN',
    decimals: 2,
  },
  {
    code: 'BHD',
    decimals: 3,
  },
  {
    code: 'BIF',
    decimals: 0,
  },
  {
    code: 'BMD',
    decimals: 2,
  },
  {
    code: 'BND',
    decimals: 2,
  },
  {
    code: 'BOB',
    decimals: 2,
  },
  {
    code: 'BOV',
    decimals: 2,
  },
  {
    code: 'BRL',
    decimals: 2,
  },
  {
    code: 'BSD',
    decimals: 2,
  },
  {
    code: 'BTN',
    decimals: 2,
  },
  {
    code: 'BWP',
    decimals: 2,
  },
  {
    code: 'BYR',
    decimals: 0,
  },
  {
    code: 'BZD',
    decimals: 2,
  },
  {
    code: 'CAD',
    decimals: 2,
  },
  {
    code: 'CDF',
    decimals: 2,
  },
  {
    code: 'CHE',
    decimals: 2,
  },
  {
    code: 'CHF',
    decimals: 2,
  },
  {
    code: 'CHW',
    decimals: 2,
  },
  {
    code: 'CLF',
    decimals: 0,
  },
  {
    code: 'CLP',
    decimals: 0,
  },
  {
    code: 'CNY',
    decimals: 2,
  },
  {
    code: 'COP',
    decimals: 2,
  },
  {
    code: 'COU',
    decimals: 2,
  },
  {
    code: 'CRC',
    decimals: 2,
  },
  {
    code: 'CUC',
    decimals: 2,
  },
  {
    code: 'CUP',
    decimals: 2,
  },
  {
    code: 'CVE',
    decimals: 0,
  },
  {
    code: 'CZK',
    decimals: 2,
  },
  {
    code: 'DJF',
    decimals: 0,
  },
  {
    code: 'DKK',
    decimals: 2,
  },
  {
    code: 'DOP',
    decimals: 2,
  },
  {
    code: 'DZD',
    decimals: 2,
  },
  {
    code: 'EGP',
    decimals: 2,
  },
  {
    code: 'ERN',
    decimals: 2,
  },
  {
    code: 'ETB',
    decimals: 2,
  },
  {
    code: 'EUR',
    decimals: 2,
  },
  {
    code: 'FJD',
    decimals: 2,
  },
  {
    code: 'FKP',
    decimals: 2,
  },
  {
    code: 'GBP',
    decimals: 2,
  },
  {
    code: 'GEL',
    decimals: 2,
  },
  {
    code: 'GHS',
    decimals: 2,
  },
  {
    code: 'GIP',
    decimals: 2,
  },
  {
    code: 'GMD',
    decimals: 2,
  },
  {
    code: 'GNF',
    decimals: 0,
  },
  {
    code: 'GTQ',
    decimals: 2,
  },
  {
    code: 'GYD',
    decimals: 2,
  },
  {
    code: 'HKD',
    decimals: 2,
  },
  {
    code: 'HNL',
    decimals: 2,
  },
  {
    code: 'HRK',
    decimals: 2,
  },
  {
    code: 'HTG',
    decimals: 2,
  },
  {
    code: 'HUF',
    decimals: 2,
  },
  {
    code: 'IDR',
    decimals: 2,
    symbol: 'Rp',
  },
  {
    code: 'ILS',
    decimals: 2,
  },
  {
    code: 'INR',
    decimals: 2,
  },
  {
    code: 'IQD',
    decimals: 3,
  },
  {
    code: 'IRR',
    decimals: 0,
  },
  {
    code: 'ISK',
    decimals: 0,
  },
  {
    code: 'JMD',
    decimals: 2,
  },
  {
    code: 'JOD',
    decimals: 3,
  },
  {
    code: 'JPY',
    decimals: 0,
  },
  {
    code: 'KES',
    decimals: 2,
  },
  {
    code: 'KGS',
    decimals: 2,
  },
  {
    code: 'KHR',
    decimals: 2,
  },
  {
    code: 'KMF',
    decimals: 0,
  },
  {
    code: 'KPW',
    decimals: 0,
  },
  {
    code: 'KRW',
    decimals: 0,
    symbol: '₩',
  },
  {
    code: 'KWD',
    decimals: 3,
  },
  {
    code: 'KYD',
    decimals: 2,
  },
  {
    code: 'KZT',
    decimals: 2,
  },
  {
    code: 'LAK',
    decimals: 0,
  },
  {
    code: 'LBP',
    decimals: 0,
  },
  {
    code: 'LKR',
    decimals: 2,
  },
  {
    code: 'LRD',
    decimals: 2,
  },
  {
    code: 'LSL',
    decimals: 2,
  },
  {
    code: 'LTL',
    decimals: 2,
  },
  {
    code: 'LVL',
    decimals: 2,
  },
  {
    code: 'LYD',
    decimals: 3,
  },
  {
    code: 'MAD',
    decimals: 2,
  },
  {
    code: 'MDL',
    decimals: 2,
  },
  {
    code: 'MGA',
    decimals: 0,
  },
  {
    code: 'MKD',
    decimals: 0,
  },
  {
    code: 'MMK',
    decimals: 0,
  },
  {
    code: 'MNT',
    decimals: 2,
  },
  {
    code: 'MOP',
    decimals: 2,
  },
  {
    code: 'MRO',
    decimals: 0,
  },
  {
    code: 'MUR',
    decimals: 2,
  },
  {
    code: 'MVR',
    decimals: 2,
  },
  {
    code: 'MWK',
    decimals: 2,
  },
  {
    code: 'MXN',
    decimals: 2,
  },
  {
    code: 'MXV',
    decimals: 2,
  },
  {
    code: 'MYR',
    decimals: 2,
  },
  {
    code: 'MZN',
    decimals: 2,
  },
  {
    code: 'NAD',
    decimals: 2,
  },
  {
    code: 'NGN',
    decimals: 2,
  },
  {
    code: 'NIO',
    decimals: 2,
  },
  {
    code: 'NOK',
    decimals: 2,
  },
  {
    code: 'NPR',
    decimals: 2,
  },
  {
    code: 'NZD',
    decimals: 2,
  },
  {
    code: 'OMR',
    decimals: 3,
  },
  {
    code: 'PAB',
    decimals: 2,
  },
  {
    code: 'PEN',
    decimals: 2,
  },
  {
    code: 'PGK',
    decimals: 2,
  },
  {
    code: 'PHP',
    decimals: 2,
  },
  {
    code: 'PKR',
    decimals: 2,
  },
  {
    code: 'PLN',
    decimals: 2,
  },
  {
    code: 'PYG',
    decimals: 0,
  },
  {
    code: 'QAR',
    decimals: 2,
  },
  {
    code: 'RON',
    decimals: 2,
  },
  {
    code: 'RSD',
    decimals: 2,
  },
  {
    code: 'RUB',
    decimals: 2,
  },
  {
    code: 'RWF',
    decimals: 0,
  },
  {
    code: 'SAR',
    decimals: 2,
  },
  {
    code: 'SBD',
    decimals: 2,
  },
  {
    code: 'SCR',
    decimals: 2,
  },
  {
    code: 'SDG',
    decimals: 2,
  },
  {
    code: 'SEK',
    decimals: 2,
  },
  {
    code: 'SGD',
    decimals: 2,
    locale: 'en-SG',
  },
  {
    code: 'SHP',
    decimals: 2,
  },
  {
    code: 'SLL',
    decimals: 0,
  },
  {
    code: 'SOS',
    decimals: 2,
  },
  {
    code: 'SRD',
    decimals: 2,
  },
  {
    code: 'SSP',
    decimals: 2,
  },
  {
    code: 'STD',
    decimals: 0,
  },
  {
    code: 'SYP',
    decimals: 2,
  },
  {
    code: 'SZL',
    decimals: 2,
  },
  {
    code: 'THB',
    decimals: 2,
  },
  {
    code: 'TJS',
    decimals: 2,
  },
  {
    code: 'TMT',
    decimals: 2,
  },
  {
    code: 'TND',
    decimals: 3,
  },
  {
    code: 'TOP',
    decimals: 2,
  },
  {
    code: 'TRY',
    decimals: 2,
  },
  {
    code: 'TTD',
    decimals: 2,
  },
  {
    code: 'TWD',
    decimals: 2,
  },
  {
    code: 'TZS',
    decimals: 2,
  },
  {
    code: 'UAH',
    decimals: 2,
  },
  {
    code: 'UGX',
    decimals: 2,
  },
  {
    code: 'USD',
    decimals: 2,
    locale: 'en-US',
  },
  {
    code: 'USN',
    decimals: 2,
  },
  {
    code: 'USS',
    decimals: 2,
  },
  {
    code: 'UYI',
    decimals: 0,
  },
  {
    code: 'UYU',
    decimals: 2,
  },
  {
    code: 'UZS',
    decimals: 2,
  },
  {
    code: 'VEF',
    decimals: 2,
  },
  {
    code: 'VND',
    decimals: 0,
  },
  {
    code: 'VUV',
    decimals: 0,
  },
  {
    code: 'WST',
    decimals: 2,
  },
  {
    code: 'XAF',
    decimals: 0,
  },
  {
    code: 'XAG',
    decimals: null,
  },
  {
    code: 'XAU',
    decimals: null,
  },
  {
    code: 'XBA',
    decimals: null,
  },
  {
    code: 'XBB',
    decimals: null,
  },
  {
    code: 'XBC',
    decimals: null,
  },
  {
    code: 'XBD',
    decimals: null,
  },
  {
    code: 'XCD',
    decimals: 2,
  },
  {
    code: 'XDR',
    decimals: null,
  },
  {
    code: 'XFU',
    decimals: null,
  },
  {
    code: 'XOF',
    decimals: 0,
  },
  {
    code: 'XPD',
    decimals: null,
  },
  {
    code: 'XPF',
    decimals: 0,
  },
  {
    code: 'XPT',
    decimals: null,
  },
  {
    code: 'XTS',
    decimals: null,
  },
  {
    code: 'XXX',
    decimals: null,
  },
  {
    code: 'YER',
    decimals: 2,
  },
  {
    code: 'ZAR',
    decimals: 2,
  },
  {
    code: 'ZMW',
    decimals: 2,
  },
];
